// web-ctr/src/lib/api.js
// Minimal fetch wrapper. No auth: every Ship A endpoint is public by design
// (schools sign up, students browse). Errors throw with the server's code.

export class ApiError extends Error {
  constructor(code, status, body) {
    super(code);
    this.code = code;
    this.status = status;
    this.body = body;
  }
}

async function call(path, options = {}) {
  const res = await fetch(path, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError(body.code || body.error || `http_${res.status}`, res.status, body);
  return body;
}

export const api = {
  get: (path) => call(path),
  post: (path, body) => call(path, { method: 'POST', body: JSON.stringify(body) }),
};

/** The school slug this hostname addresses, or null for the public site.
 *  `?school=` override kept for local dev without DNS mapping.
 *  Reads window.location, which the wildcard Worker (workers/ctr-wildcard)
 *  never changes, so no X-Forwarded-Host handling belongs here; server-side
 *  readers use utils/ctr-host.js, which prefers that header. The suffix and
 *  www rules must stay in step with it (tests/ctr-forwarded-host.test.js). */
export function slugFromLocation(loc = window.location) {
  const q = new URLSearchParams(loc.search).get('school');
  if (q) return q.toLowerCase();
  const host = loc.hostname.toLowerCase();
  if (host.endsWith('.clearedto.rent')) {
    const slug = host.slice(0, -'.clearedto.rent'.length);
    if (slug && slug !== 'www') return slug;
  }
  return null;
}
